import BaseAPI from "../api";

const path: string = "budgets";

export interface createBudgetType {
  budgetName: string;
  budgetNo: string;
  budgetStatus: string;
  budgetOther: any;
}
export interface getBudgets {
  page?: number;
  limit?: number;
  keyword?: string;
}
export interface updateBudget {
  budgetName: string;
  budgetNo: string;
  budgetStatus: string;
  budgetOther: boolean;
}

export class BudgetApi extends BaseAPI {
  public static createBudget(props: createBudgetType): Promise<any> {
    return this.api.post(`${path}`, props).then((res) => res);
  }
  public static getBudgets(props: getBudgets): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
  public static updateBudget(
    idBudget: number,
    props: updateBudget
  ): Promise<any> {
    return this.api.patch(`${path}/${idBudget}`, props).then((res) => res);
  }
  public static getDetailBudget(idBudget: number): Promise<any> {
    return this.api.get(`${path}/${idBudget}`).then((res) => res);
  }
}
